import {queries} from '@cypro/engine/queries'
import {useQuery} from '@rocicorp/zero/react'

export function useGetResourceEvents(args: Parameters<typeof queries.eventLogs.getResourceEvents>[0]) {
  return useQuery(
    queries.eventLogs.getResourceEvents({
      ...args,
      resourceId: args.resourceId || '',
    }),
    {enabled: Boolean(args.resourceId)}
  )
}
